import axios from 'axios'

export default {
  state: {
    sections: [],
    // questions: [],
  },
  mutations: {
    setSections(state, payload) {
      state.sections = payload
    },
    // setQuestions(state, payload) {
    //   state.questions = payload
    // },
  },
  actions: {
    querySections({dispatch, commit}) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'sections')
        .then(res => {
          commit('setSections', res.data)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    storeSection({dispatch, commit}, payload) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'sections', payload)
        .then(res => {
          dispatch('querySections')
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    updateSection({dispatch, commit}, payload) {
      dispatch('setPreloader', true)
      axios.patch(process.env.VUE_APP_API_ENDPOINT + 'sections/' + payload[0], payload[1])
        .then(res => {
          dispatch('querySections')
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    destroySection({dispatch, commit}, user_id) {
      dispatch('setPreloader', true)
      axios.delete(process.env.VUE_APP_API_ENDPOINT + 'sections/' + user_id)
        .then(res => {
          dispatch('querySections')
          dispatch('setToast', {status: 'success', message: res.data})
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    sortSections({commit, state, dispatch}, payload) {
      let sort_ids = []
      for (let i = 0; i < payload.length; i++) {
        sort_ids.push(payload[i].id)
      }
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'sections/sort', {sort: sort_ids})
        .then(res => {
          dispatch('querySections')
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },

    storeQuestion({dispatch, commit}, payload) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'questions', payload)
        .then(res => {
          dispatch('querySections')
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('closeModal', true)
          dispatch('setSectionId', null)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    updateQuestion({dispatch, commit}, payload) {
      dispatch('setPreloader', true)
      axios.patch(process.env.VUE_APP_API_ENDPOINT + 'questions/' + payload[0], payload[1])
        .then(res => {
          dispatch('querySections')
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('closeModal', true)
          dispatch('setPreloader', false)
        })
        .catch(error => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    destroyQuestion({dispatch, commit}, question_id) {
        dispatch('setPreloader', true)
        axios.delete(process.env.VUE_APP_API_ENDPOINT + 'questions/' + question_id)
            .then(res => {
                dispatch('querySections')
                dispatch('setToast', {status: 'success', message: res.data.message})
                dispatch('closeModal', true)
                dispatch('setPreloader', false)
            })
            .catch(error => {
                dispatch('setToastHttpError', error.response, {root: true})
            })
    },
    sortQuestions({commit, state, dispatch}, payload) {
      let sort_ids = []
      for (let i = 0; i < payload.length; i++) {
        sort_ids.push(payload[i].id)
      }
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'questions/sort', {sort: sort_ids})
        .then(res => {
          dispatch('querySections')
          dispatch('setToast', {status: 'success', message: res.data.message})
          dispatch('setPreloader', false)
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
  },
  getters: {
    getSections(state) {
      return state.sections
    },
  }
}